/**
 * In Safari private mode, with blocked cookies, or from a cross-origin iframe,
 * accessing "window.localStorage" itself throws a SecurityError, so try/catch is needed
 * around every access, not just around getItem/setItem/removeItem.
 * https://lun.sentry.io/issues/JS-LUNUA-HJC
 */
const safeLocalStorage = {
  getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  },

  setItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // localStorage is unavailable — nothing to save
    }
  },

  removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      // localStorage is unavailable — nothing to remove
    }
  },

  keys() {
    try {
      return Object.keys(window.localStorage);
    } catch (error) {
      return [];
    }
  },
};

export default safeLocalStorage;
